import { render, staticRenderFns } from "./DocutaxRequestMessageTemplate.vue?vue&type=template&id=571fa61e&"
import script from "./DocutaxRequestMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./DocutaxRequestMessageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DocutaxRequestMessageTemplate.vue?vue&type=style&index=0&id=571fa61e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports